<template>
    <div v-if="list.length>0" class="dropdown">
        <a href="#" class="dropdown-ellipses dropdown-toggle p-2" role="button" data-bs-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <i :class="icon" :style="iconStyle"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-end">
            <a v-for="btn in list" :key="btn.id" class="dropdown-item" @click="btn.onClick">
                <div class="d-flex justify-content-start align-items-center">
                    <div class="d-flex justify-content-center align-items-center" :style="{ width: '20px', marginRight: '0.6rem' }">
                        <i :class="[btn.icon]" v-if="btn.icon"></i>
                    </div>
                    {{ btn.name }}
                </div>
            </a>
        </div>
    </div>
</template>
<script>
export default ({
    name: "ActionDropdown",
    props: {
        btnList: {
            type: Array,
            default: function () {
                return []
            }
        },
        icon: {
            type: Array,
            default: function () {
                return ['fa', 'fa-ellipsis-v']
            }
        },
        iconStyle: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    computed: {
        list() {
            //filter only visible button
            return this.btnList.filter((value) => value.visible)
        }
    }
})
</script>
<style scoped>
.dropdown-ellipses {
    color: #6E84A3 !important;
    font-size: 1.1625rem !important;
}

.dropdown-ellipses:hover {
    color: #000000 !important;
}

.dropdown-item {
    color: #6E84A3 !important;
    cursor: pointer;
    padding-left: 1.1rem !important;
}

.dropdown-item:hover {
    background-color: #efefef;
    color: #000000 !important;
}
</style>